import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import styles from "./Loader.module.scss";

const Spinner = dynamic(
  () => import("@chakra-ui/react").then(mod => mod.Spinner),
  {
    loading: () => <div>Loading...</div>,
    ssr: false,
  }
);

interface Props {
  overlay?: boolean;
}

// 회원 관리 대응 관련 수정 필요
export default function Loader({ overlay = false }: Props): React.ReactElement {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // 컴포넌트가 마운트될 때 클라이언트 사이드인지 설정
    // createPortal(document.body) 게이트용 클라이언트 마운트 플래그 — SSR 렌더 중 불가
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsClient(true);
  }, []);

  const loaderContent = (
    <div
      className={
        overlay ? styles.overlayLoaderContainer : styles.loaderContainer
      }
      data-testid="loader"
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="gray.700"
        size="xl"
        className={overlay ? styles.overlayLoader : ""}
      />
    </div>
  );

  if (isClient && overlay) {
    // Portal을 사용하여 body 태그 내부에 로더를 삽입
    return ReactDOM.createPortal(loaderContent, document.body);
  }

  return loaderContent;
}
